import LMPBPapi from 'api/lmpbp';
import handleResponse from './utils/handleResponse';

export function subscribeToAwsIotLMPBP() {
    return handleResponse({
        promise: LMPBPapi().get('/iot/notifications/subscription')
    })
}